import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { AuthStore } from './auth-store';

export const authGuard = () => {
  const router = inject(Router);
  const store = inject(AuthStore);

  if (store.isAuthenticated()) {
    return true;
  }

  return router.parseUrl('/account/login');
};
